import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlClientUpdateInput } from "~/__generated__";

import { ClientUpdateDocument } from "../mutations.generated";

export default function useClientUpdate(id: string) {
    const [updateClient, { data, loading, error }] = useMutation(ClientUpdateDocument, {
        refetchQueries: ["MeGetClientInfo"],
    });

    return {
        updateClient: useCallback(
            (input: Omit<GqlClientUpdateInput, "clientId">) =>
                updateClient({
                    variables: {
                        input: {
                            ...input,
                            clientId: id,
                        },
                    },
                }),
            [updateClient, id],
        ),
        data,
        loading,
        error,
    };
}
